var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle"},[_c('div',{staticClass:"middle-nav"},[_c('navList')],1),_c('div',{staticClass:"middle-tray"})])
}
var staticRenderFns = []

export { render, staticRenderFns }